/**
 * Flag de PostHog del anuncio de Cashea que aparece al entrar (por grupo tenant, fail-closed):
 * con el flag apagado o sin cargar no se muestra.
 */
export const CASHEA_ANNOUNCEMENT_FLAG = 'cashea-announcement';

/**
 * Marca de "ya lo vio" en `instructionsNotToShow` del usuario, la misma lista que usan los videos
 * tutoriales: queda guardada en el servidor, así que se ve una sola vez por usuario en cualquier
 * dispositivo. Para volver a mostrarlo a todos (otra campaña), se cambia esta clave.
 */
export const CASHEA_ANNOUNCEMENT_SEEN_KEY = 'anuncio-cashea-2026-10';

/** A quién le habla: sin Cashea se le ofrece conectarlo; con solo el QR, sumar Link. */
export type CasheaAnnouncementVariant = 'connect' | 'link';
